import actions from './constants';

export const showTasks = (
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
  view,
) => ({
  type: actions.SHOW_REQUEST_TASKS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
  view,
});

export const showTasksError = (category, error) => ({
  type: actions.SHOW_REQUEST_TASKS_ERROR,
  category,
  error,
});

export const closeTasks = ({ category }) => ({
  type: actions.CLOSE_REQUEST_TASKS,
  category,
});

export const showTaskViews = (
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_REQUEST_TASK_VIEWS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showTaskViewsError = (category, error) => ({
  type: actions.SHOW_REQUEST_TASK_VIEWS_ERROR,
  category,
  error,
});

export const showActiveRequestTask = (task, request) => ({
  type: actions.SHOW_ACTIVE_REQUEST_TASK,
  task,
  request,
});

export const showActiveRequestTaskError = (code, error) => ({
  type: actions.SHOW_ACTIVE_REQUEST_TASK_ERROR,
  code,
  error,
});

export const showUpdateRequestTaskSuccess = (code, name, result, silent) => ({
  type: actions.SHOW_UPDATE_REQUEST_TASK_SUCCESS,
  code,
  name,
  result,
  silent,
});

export const completeRequestTasksSuccess = (items) => ({
  type: actions.COMPLETE_REQUEST_TASKS_SUCCESS, items,
});

export const showUpdateRequestTaskError = (category, code, name, error, silent) => ({
  type: actions.SHOW_UPDATE_REQUEST_TASK_ERROR,
  category,
  code,
  name,
  error,
  silent,
});

export const showManageRequestTaskError = (error) => ({
  type: actions.SHOW_MANAGE_REQUEST_TASK_ERROR,
  error,
});

export const showManageRequestTaskSuccess = (code, name, result) => ({
  type: actions.SHOW_MANAGE_REQUEST_TASK_SUCCESS,
  code,
  name,
  result,
});
